// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__FaumU","dark":"NotFoundPage_dark__akg9b","box":"NotFoundPage_box__hVBxm","title":"NotFoundPage_title__bXj3q","btn":"NotFoundPage_btn__4bupu"};